/**
 * Monta a URL absoluta para abrir o serviço correspondente no Gov.pi Cidadão.
 * Usa as variáveis injetadas em build (PORTAL_URL + GOV_PI_URL).
 */
export function getGovPiExternalUrl(portalUrl, govPiUrl) {
    if (!portalUrl || !govPiUrl) {
        return null;
    }
    return portalUrl + govPiUrl;
}
